import React, { useEffect } from 'react';
import pkceChallenge from 'pkce-challenge';
import { generateRandomString } from 'stash/utils';
import { buildAuthRedirect } from 'stash/routes/SessionManagementRoutes/utils';
import { setCookie, deleteCookie, getCookie } from 'stash/utils/cookies';
import useNudata from 'stash/hooks/nudata';

const AuthRedirect = ({ redirect }) => {
	const { nudataQueryParams } = useNudata();

	useEffect(() => {
		const STASH_ENV =
			window.Stash.env === '__STASH_ENV__' && getCookie('stocktonDev')
				? 'stockton_dev'
				: window.Stash.env;

		deleteCookie('AUTH_STATE_PARAM');
		const state = generateRandomString();
		setCookie('AUTH_STATE_PARAM', state);

		deleteCookie('AUTH_CODE_VERIFIER');
		const { code_verifier, code_challenge } = pkceChallenge();
		setCookie('AUTH_CODE_VERIFIER', code_verifier);

		const loginUrl = buildAuthRedirect(
			STASH_ENV,
			state,
			code_challenge,
			nudataQueryParams,
			redirect
		);
		window.location.href = loginUrl;
	}, []);
	return <div />;
};

export default AuthRedirect;
